//---------------------------------------------------------------------------------------------------
// ## IMPORTS ##
// Library Imports
import { useState } from "react";

// Material ui Imports
import { SxProps } from "@mui/system";
import { Grid, Typography, styled, useTheme } from "@mui/material";
import SearchIcon from "@mui/icons-material/SearchRounded";

// Custom components imports (and hooks and helpers)
import { VTButton, VTTextField, VTTypography, VTUserSelectTable } from "@virtus-tech-repository/virtus-tech-repository";

// Media imports

import { useAppDispatch, useAppSelector } from "../../store/hooks";

import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs, { Dayjs } from "dayjs";
import { DateCalendar, DateField, LocalizationProvider } from "@mui/x-date-pickers";
import ArrowRightIcon from "@mui/icons-material/ArrowRight";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import SearchRoundedIcon from "@mui/icons-material/SearchRounded";
import { UserAttemptRowObjectType } from "@virtus-tech-repository/virtus-tech-repository/lib/components/VTTableBasic";
export const TemplateSceneImg = styled("img")(({ theme }) => ({
    borderRadius: "15px",
    height: "200px",
    width: "100%",
    objectFit: "cover",
    ":hover": {
        cursor: "pointer",
    },
}));

//---------------------------------------------------------------------------------------------------
// ## INTERFACES ##
interface IProps {
    sx?: SxProps;
}

export default function VTGroupsSidePanel({ sx }: IProps) {
    //-------------------------------------------------------------------------------------------------
    // ## USE STATE ##

    const dispatch = useAppDispatch();
    const theme = useTheme();
    const [searchValue, setSearchValue] = useState<string>("");

    const [dateShow, setDateShow] = useState<boolean>(true);
    const [startDate, setStartDate] = useState<Dayjs>(dayjs("2022-04-17"));

    const [endDate, setEndDate] = useState<Dayjs>(dayjs("2022-04-17"));

    const demoGroups = [
        { userId: "1", name: "Group1", lastAttemptDate: new Date() },
        { userId: "2", name: "Group2", lastAttemptDate: new Date() },
        { userId: "3", name: "Group3", lastAttemptDate: new Date() },
    ];

    const demoUsers = [
        { userId: "1", name: "Harry", lastAttemptDate: new Date() },
        { userId: "2", name: "Peter", lastAttemptDate: new Date() },
        { userId: "3", name: "Sam", lastAttemptDate: new Date() },
    ];

    const demoAttempts = [
        { attemptId: "1", lastAttemptDate: new Date() },
        { attemptId: "2", lastAttemptDate: new Date() },
        { attemptId: "3", lastAttemptDate: new Date() },
    ];

    return (
        <Grid
            container
            justifyContent="center"
            alignItems="flex-start"
            sx={{
                height: "calc(100vh - 70px)",
                padding: "10px",
                border: "2px dashed red",
                width: "100%",
                paddingTop: "40px",
                ...sx,
            }}
        >
            {/*-----------------------------------------------------------------------------------------*/}
            {/* Images search */}

            <Grid item xs={12} container justifyContent={"center"}>
                {" "}
                <Grid item xs={11}>
                    <VTTextField
                        placeholder={"Search Groups"}
                        sx={{
                            marginTop: "20px",
                        }}
                        value={searchValue}
                        onChange={(textInput: string) => setSearchValue(textInput)}
                        type={"text"}
                        endIcon={<SearchRoundedIcon />}
                    />
                </Grid>
                <VTUserSelectTable
                    sx={{ marginInline: "5px", marginTop: "40px" }}
                    tableData={[
                        ...demoGroups.map((menuElement: { userId: string; name: string; lastAttemptDate: Date }) => {
                            return {
                                id: menuElement.userId,
                                name: menuElement.name,
                            } as UserAttemptRowObjectType;
                        }),
                    ]}
                    onRowSelected={(e: any) => {
                        // dispatch(setCurrentUser(e.name));
                    }}
                />
            </Grid>
        </Grid>
    );
}
